module.exports = __webpack_public_path__ + "static/media/abc.4cd915ad.jpg";